import { styled, TableBody, TableRow } from '@mui/material'
import InvoiceEditTableCell from '../invoice-edit-table-cell/invoice-edit-table-cell'
import InvoiceEditTableTax from './invoice-edit-table-tax/invoice-edit-table-tax'
import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import InvoiceEditTableActions from './invoice-edit-table-actions/invoice-edit-table-actions'
import { InvoiceLineItem } from '../../../../../store/invoices/invoices.types'
import { handleChange } from './invoice-edit-table-body.utils'

export type InvoiceEditTableBodyProps = {
  lines: InvoiceLineItem[]
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
}

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.secondary.light,
  },

  'td, th': { border: 0 },
}))

const InvoiceEditTableBody = ({
  lines,
  setLines,
}: InvoiceEditTableBodyProps) => {
  return (
    <TableBody>
      {[...lines]
        .sort((a, b) => a.position - b.position)
        .map((line, index) => (
          <StyledTableRow key={line.id}>
            <InvoiceEditTableCell
              value={line.lineName}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                handleChange(event, 'lineName', line, setLines)
              }
            />
            <InvoiceEditTableCell
              value={line.description}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                handleChange(event, 'description', line, setLines)
              }
            />
            <InvoiceEditTableCell
              value={line.rate}
              type="number"
              currencyFormat
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                handleChange(event, 'rate', line, setLines)
              }
            />
            <InvoiceEditTableCell
              value={line.quantity}
              type="number"
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                handleChange(event, 'quantity', line, setLines)
              }
            />
            <InvoiceEditTableCell
              value={
                line.lineTotal !== 0
                  ? line.lineTotal
                  : line.rate * line.quantity
              }
              type="number"
              currencyFormat
              disabled
            />
            <InvoiceEditTableTax
              checked={line.tax}
              line={line}
              setLines={setLines}
            />
            <InvoiceEditTableActions
              index={index}
              lines={lines}
              setLines={setLines}
            />
          </StyledTableRow>
        ))}
    </TableBody>
  )
}

export default InvoiceEditTableBody
